import React, { useState } from "react";
import { ShimmerContentBlock } from "react-shimmer-effects";
import { ImHammer2 } from "react-icons/im";
import { navigateToProperty } from "@/utils/propertyNavigation";

const PropertyDetailsCard = ({ listingOfferDetails, propertyDetails }) => {
  const [imageUrl, setImageUrl] = useState(
    propertyDetails?.imageDetails?.[0]?.thumbnailUrl || ""
  );

  const defaultImage = () => {
    setImageUrl("/assets/images/imageOnTheWay.webp");
  };

  if (!listingOfferDetails && !propertyDetails) {
    return (
      <div className="offer-loader p-5 mb-5">
        <ShimmerContentBlock
          title
          text
          cta
          thumbnailWidth={370}
          thumbnailHeight={370}
        />
      </div>
    );
  }
   const navigateToPdp = () => {
    navigateToProperty(`/property/${propertyDetails?.propertyId}`, propertyDetails?.commonAttributes?.propCategory, propertyDetails?.commonAttributes?.status);
  };

  return (
    <div>
      <div className="offer-property-card">
        <img src={imageUrl} alt="Image on the way" onError={defaultImage}  onClick={()=>navigateToPdp()}
               className="cursor-pointer"/>
        <div className="offer-property-data">
          <p className="streetNumber mb-0">
            {propertyDetails?.address?.streetNumber}{" "}
            {propertyDetails?.address?.streetName}
          </p>
          <p className="streetNumber mb-0">
            {propertyDetails?.address?.city},{propertyDetails?.address?.state}{" "}
            {propertyDetails?.address?.zip}
          </p>
          <p className="bedsandbath">
            {propertyDetails?.commonAttributes?.bedroomsNum} Beds /{" "}
            {propertyDetails?.commonAttributes?.bathsNum} Baths
          </p>
          <p className="align-items-center">
            <spam className="hammer">
            <ImHammer2 />

            </spam>

            {listingOfferDetails?.listingPrice>0 ? (
              <>
               <span className="listing-price-label">Listing Price</span> {" "}
                <span className="listing-price-val">{listingOfferDetails?.listingPriceFormatted}</span>{" "}
              </>
            ) : (
              <>
                <span className="listing-price-label">{listingOfferDetails?.currentLabel}</span>{" "}
               <span className="listing-price-val"> {listingOfferDetails?.currentDisplayAmountFormatted}</span>
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PropertyDetailsCard;
